import { useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useInvoices() {
  const getInvoices = useCallback(async ({ userId, businessId }) => {
    let query = supabase
      .from('invoices')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });
    if (businessId) query = query.eq('business_id', businessId);
    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  }, []);

  const getInvoiceById = useCallback(async (id) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');
    const { data, error } = await supabase
      .from('invoices')
      .select('*')
      .eq('id', id)
      .eq('user_id', user.id)  // defense-in-depth
      .single();
    if (error) throw error;
    return data;
  }, []);

  const createInvoice = useCallback(async (invoice) => {
    const { data, error } = await supabase
      .from('invoices')
      .insert(invoice)
      .select()
      .single();
    if (error) throw error;
    return data;
  }, []);

  const updateInvoice = useCallback(async (id, updates) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');
    const { data, error } = await supabase
      .from('invoices')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', id)
      .eq('user_id', user.id)  // defense-in-depth: RLS + explicit user check
      .select()
      .single();
    if (error) throw error;
    return data;
  }, []);

  const deleteInvoice = useCallback(async (id) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');
    const { error } = await supabase
      .from('invoices')
      .delete()
      .eq('id', id)
      .eq('user_id', user.id);  // defense-in-depth: RLS + explicit user check
    if (error) throw error;
  }, []);

  return { getInvoices, getInvoiceById, createInvoice, updateInvoice, deleteInvoice };
}
